import React, { useEffect, useState } from "react";
import api from "@api";
import { useParams } from "react-router-dom";
import { useDomain } from "@useDomain";

import PlayersBasketball from "./SportPages/Basketball/PlayerBasketballPublic.jsx";
import PlayersTennis from "./SportPages/Tennis/PlayerTennisPublic.jsx";

function PlayerPublic() {
  const [playerData, setPlayerData] = useState(null);
  const [loading, setLoading] = useState(true);

  const { id, slug: routeSlug } = useParams();
  const { domain, slug: domainSlug, organization } = useDomain();

  const activeSlug = routeSlug || domainSlug;

  useEffect(() => {
    const getPlayer = async () => {
      try {
        setLoading(true);

        const response = await api.get(`/api/playersv2/${id}/basic`, {
          params: activeSlug
            ? { slug: activeSlug, scope: "active" }
            : { domain, scope: "active" },
        });

        const basicData = response.data;
        console.log("PLAYER BASIC DATA:", basicData);

        const gameIds = [
          ...new Set(
            (basicData.gameStats || [])
              .map((entry) => entry.game_id)
              .filter(Boolean)
          ),
        ];

        const racquetMatchesByGame = await Promise.all(
          gameIds.map(async (gameId) => {
            const matchRes = await api.get(`/api/gamesv2/${gameId}/racquet-matches`);
            return matchRes.data || [];
          })
        );

        setPlayerData({
          ...basicData,
          racquetMatches: racquetMatchesByGame.flat(),
        });

      } catch (error) {
        console.error(
          "Error fetching player:",
          error.response?.data || error.message
        );
      } finally {
        setLoading(false);
      }
    };

    getPlayer();
  }, [id, domain, activeSlug]);


  const getSportName = () => {
    const orgSport =
      organization?.sports?.[0]?.type ||
      organization?.sport?.type ||
      organization?.sport_type ||
      "";

    if (orgSport) {
      return String(orgSport).toLowerCase();
    }

    const activeEntry =
      playerData?.teamHistory?.find((entry) => entry.season?.active) ||
      playerData?.teamHistory?.[0];

    const playerSport =
      activeEntry?.league?.sport?.type ||
      activeEntry?.league?.sport?.name ||
      activeEntry?.sport?.type ||
      activeEntry?.sport?.name ||
      playerData?.league?.sport?.type ||
      playerData?.league?.sport?.name ||
      "";

    return String(playerSport).toLowerCase();
  };

  if (loading) return null;

  if (!playerData) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        Player not found.
      </div>
    );
  }

  const sportName = getSportName();



  if (sportName === "tennis") {
    return <PlayersTennis playerData={playerData} />;
  }
  if (sportName === "basketball") {
    return <PlayersBasketball playerData={playerData} />;
  }
}

export default PlayerPublic;